/** saves Accounts
@payload { Array }
*/
export const SAVE_ACCOUNTS = (state, payload) => {
	state.accounts = payload.balanceViews
}

/** saves Cards List
@payload { Array }
*/
export const SAVE_CARDS = (state, payload) => {
	state.cardsList = payload
}

/** saves Card Group Plafond
@payload { Object }
*/
export const SAVE_CARD_GROUP_PLAFOND = (state, payload) => {
	state.cardGroupPlafond = payload.availablePlafond
}

/** saves Last Batchfile Charge List
@payload { Object }
*/
export const SAVE_LAST_BATCHFILE_CHARGE_LIST = (state, payload) => {
	state.lastBatchfileChargeList = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.accounts = []
	state.cardsList = []
	state.cardGroupPlafond = []
	state.lastBatchfileChargeList = []
}
